import { OptionsWithExtraProps } from 'notistack';

import { createAppAsyncThunk } from '@/domain/store.thunk';

export const displaySnackbarSuccess = createAppAsyncThunk(
  'snackbar/displaySnackbarSuccess',
  async (
    {
      message,
      extraProps,
    }: {
      message: React.ReactNode | string;
      extraProps?: OptionsWithExtraProps<'success'>;
    },
    { extra: { snackbarGateway } },
  ): Promise<void> => {
    snackbarGateway.success(message, extraProps);
  },
);

export const displaySnackbarError = createAppAsyncThunk(
  'snackbar/displaySnackbarError',
  async (
    {
      message,
      extraProps,
    }: {
      message: React.ReactNode | string;
      extraProps?: OptionsWithExtraProps<'error'>;
    },
    { extra: { snackbarGateway } },
  ): Promise<void> => {
    snackbarGateway.error(message, extraProps);
  },
);

export const displaySnackbarWarning = createAppAsyncThunk(
  'snackbar/displaySnackbarWarning',
  async (
    {
      message,
      extraProps,
    }: {
      message: React.ReactNode | string;
      extraProps?: OptionsWithExtraProps<'warning'>;
    },
    { extra: { snackbarGateway } },
  ): Promise<void> => {
    snackbarGateway.warning(message, extraProps);
  },
);
